import { useCookies } from "vue3-cookies";
const { cookies } = useCookies();

export {
    cookies as $cookies
}